module.exports = __webpack_public_path__ + "static/img/stay-option-icon-washingmachine.801c8ff9.svg";